import { useMutation, useQuery } from "react-query"
import { AdminSearchParameters, LoadChecklistResult, SavePrimaryGoalCompletedDatePayload, SavePrimaryGoalPayload, adminSearch, loadSuccessChecklist, saveChecklistPrimaryGoal, saveChecklistPrimaryGoalCompletedDate, saveSuccessChecklist } from "./checklistApi"
import { ChecklistItemData } from "./checklistModel"
import { notification } from "antd"

const queryKey = 'success-checklist'

export const useSuccessChecklist = (onSuccess: (result: LoadChecklistResult) => void) => {
  return useQuery([queryKey], loadSuccessChecklist, {
    onSuccess
  })
}

export const useSuccessChecklistMutation = () => {
  return useMutation((steps: ChecklistItemData[]) => saveSuccessChecklist({ steps }), {
    onError: () => {
      notification.error({
        message: `There was a problem saving your checklist. Please try again later.`
      })
    }
  })
}

export const usePrimaryGoalMutation = () => {
  return useMutation(( payload: SavePrimaryGoalPayload) => saveChecklistPrimaryGoal(payload), {
    onError: () => {
      notification.error({
        message: `There was a problem saving your primary goal. Please try again later.`
      })
    }
  })
}

export const usePrimaryGoalCompletedDateMutation = () => {
  return useMutation(( payload: SavePrimaryGoalCompletedDatePayload) => saveChecklistPrimaryGoalCompletedDate(payload), {
    onError: () => {
      notification.error({
        message: `There was a problem saving your primary goal. Please try again later.`
      })
    }
  })
}

export const useAdminSearch = (searchParameters: AdminSearchParameters) => {
  return useQuery([queryKey + '/admin-search', { searchParameters }], () => adminSearch(searchParameters))
}